/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IChangeSystemTimeScope extends angular.IScope {
        offSetDto: Wars.Domain.Model.Dtos.DateTimeOffsetDto;
        changeDateTime(): void;
        endChangeDateTime() : void;
    }

    export class ChangeSystemTimeController implements IController {
        constructor(
            private scope: IChangeSystemTimeScope,
            private testService: services.TestService,
            private userService: services.UserService)
        {
            scope.offSetDto = {
                timeDurationOption: Wars.Domain.Model.Codes.Enums.TimeDurationOption.Days,
                timeDurationValue: 0
            };
            scope.changeDateTime = () => this.changeDateTime();
            scope.endChangeDateTime = () => this.endChangeDateTime();
            this.clearDateTimeOffset();
        }

        private changeDateTime() {
            this.testService.changeDateTime(this.scope.offSetDto).then(() => {
                alert("The specified Date/Time offset has been set");
            });
        }

        private endChangeDateTime() {
            this.clearDateTimeOffset();
            this.testService.endChangeDateTime().then(() => {
                alert("The system Date/Time offset has been cleared");
            });
        }

        private clearDateTimeOffset() {
            this.scope.offSetDto = {
                timeDurationOption: Wars.Domain.Model.Codes.Enums.TimeDurationOption.Days,
                timeDurationValue: 0
            };
        }
    }
}

warsApp.registerController('ChangeSystemTimeController', ['$scope', 'testService', "userService"]);